"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSingleLinkFunctionless = exports.generateSingleLink = exports.generateMobileLink = exports.default = exports.IconLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _LunaLink = _interopRequireDefault(require("../jscomponents/LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const generateLinks = (links, className, closeDropDown, name, mouse, Link, depth) => {
  return links?.filter(link => link?.url)?.map((link, index) => {
    const {
      url,
      text
    } = link;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: className,
      key: `${text}-${name}-${index}`,
      onClick: closeDropDown
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      tabIndex: mouse ? "" : "0",
      to: url,
      style: {
        textDecoration: "none"
      },
      className: `${className} ${mouse ? "" : "tabFocus"}`,
      rel: link?.external ? "noopener" : "",
      Link: Link,
      depth: depth && depth
    }, text));
  });
};
var _default = generateLinks;
exports.default = _default;
const generateSingleLink = (link, className, closeDropDown, parentOpen, mouse, Link, depth) => {
  const url = link?.url;
  const text = link?.title || link?.text;
  return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    tabIndex: mouse ? "" : "0",
    className: `${className} ${parentOpen ? "" : "ter-mobile-mega-menu-category__name--hidden"} ${mouse ? "" : "tabFocus"}`,
    key: `${text}-${link}`,
    to: url,
    onClick: closeDropDown,
    target: link?.external ? "_blank" : "_self",
    rel: link?.external ? "noopener" : "",
    Link: Link,
    style: {
      textDecoration: "none"
    },
    depth: depth && depth
  }, text);
};
exports.generateSingleLink = generateSingleLink;
const generateSingleLinkFunctionless = (link, className, index, Link, depth) => {
  const url = link?.url;
  const text = link?.text;
  return url ? /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    key: `${text}-${index}`,
    "aria-label": `link to ${text}`,
    to: url,
    className: className,
    Link: Link,
    target: typeof link?.external === "boolean" ? link?.external ? "_blank" : "_self" : null,
    depth: depth && depth,
    contentfulId: link?.contentfulId
  }, text) : null;
};
exports.generateSingleLinkFunctionless = generateSingleLinkFunctionless;
const generateMobileLink = (link, className, closeDropDown, mouse, Link, depth) => {
  const {
    url,
    text
  } = link;
  return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    tabIndex: mouse ? "" : "0",
    key: text,
    "aria-label": `link to ${text}`,
    to: url,
    className: `${className} ${mouse ? "" : "tabFocus"}`,
    onClick: closeDropDown,
    Link: Link,
    rel: link?.external ? "noopener" : "",
    depth: depth && depth
  }, text);
};
exports.generateMobileLink = generateMobileLink;
const IconLink = _ref => {
  let {
    url,
    children,
    onClick,
    external,
    className = "icon-link",
    Link,
    depth
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: url,
    onClick: onClick ? onClick : () => {},
    target: external ? "_blank" : "_self",
    Link: Link,
    rel: Link?.external ? "noopener" : "",
    depth: depth && depth
  }, children);
};
exports.IconLink = IconLink;